export default __webpack_public_path__ + "static/brings-b483e20f0ed8ed71b0511f439b556cd8.jpg";